import React from 'react';
import './Avatar.css';

interface AvatarProps {
  name: string;
  imageUrl?: string;
  size?: number;
  fontSize?: number;
}

const getAvatarTextInitials = (fullName: string) =>
  fullName
    .split(' ')
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

const Avatar: React.FC<AvatarProps> = ({ name, imageUrl, size, fontSize }) => {
  return (
    <div
      className="user-avatar-wrapper"
      style={size ? { width: size, height: size } : {}}>
      {imageUrl ? (
        <img src={imageUrl} alt={name} className="user-avatar" />
      ) : (
        <div
          className="user-avatar-fallback"
          style={fontSize ? { fontSize } : {}}>
          {getAvatarTextInitials(name)}
        </div>
      )}
    </div>
  );
};

export default Avatar;
